import { useRef, useState, useCallback } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function AvantApres({ avant, apres, altAvant, altApres }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const update = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, pct)));
  }, []);

  const onPointerDown = (e) => {
    e.preventDefault();
    update(e.clientX);
    const move = (ev) => update(ev.clientX);
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  return (
    <div
      ref={ref}
      onPointerDown={onPointerDown}
      className="relative overflow-hidden select-none cursor-ew-resize touch-none h-[340px] md:h-[520px]"
      data-testid="avant-apres-slider"
    >
      <img src={apres} alt={altApres} loading="lazy" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={avant} alt={altAvant} loading="lazy" draggable={false} className="absolute inset-0 w-full h-full object-cover" />
      </div>

      <span className="absolute top-4 left-4 bg-black/70 text-[#C4A484] text-[10px] tracking-[0.3em] uppercase px-3 py-1.5" data-testid="avant-label">
        Avant
      </span>
      <span className="absolute top-4 right-4 bg-black/70 text-[#F5F5F0] text-[10px] tracking-[0.3em] uppercase px-3 py-1.5" data-testid="apres-label">
        Après
      </span>

      <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-[#C4A484]" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-[#C4A484] text-[#0A0A0A] flex items-center justify-center shadow-lg shadow-black/50" data-testid="avant-apres-handle">
          <ChevronsLeftRight size={18} />
        </div>
      </div>
    </div>
  );
}
